import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BookRequest, BookResponse, PromoResponse, TagResponse } from '@builtbybros/al-model';
import {FormBuilder, FormGroup} from '@angular/forms';
import {InitjsService} from '../../shared/initjs.service';
import {PromoService} from '../shared/promo.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HttpService} from '../../shared/http.service';
import {FormsService} from '../../shared/forms.service';

@Component({
  selector: 'app-promo-assign',
  templateUrl: './promo-assign.component.html',
  styleUrls: ['./promo-assign.component.scss']
})
export class PromoAssignComponent implements OnInit {
  @Input() promoId: number;
  booksSelected: BookResponse.Book[] = [];
  tagsSelected: TagResponse.Tag[] = [];
  bookUrl = '/Book/';
  tagUrl = '/Tag/';
  @Input() applyTo: number;
  @Input() itemIds: number[] = [];
  itemsSelected: BookResponse.Book[] | TagResponse.Tag[] = [];
  @Output() onAssign = new EventEmitter<string>();

  constructor(private router: Router,
              private route: ActivatedRoute,
              private httpService: HttpService,
              private initJsService: InitjsService) {
  }

  ngOnInit() {
    let url = '/PromoItem/';

    if (this.applyTo === 1) {
      this.getTags();
    } else if (this.applyTo === 2) {
      this.getBooks();
    }
  }

  getTags() {
    let tagsExpected = TagResponse.Tag;
    this.httpService.getObjects('/PromoItem/', this.promoId, tagsExpected)
      .subscribe(
        createResponse => {
          for (let item of createResponse) {
            this.tagsSelected.push(item);
            this.itemIds.push(item.id);
          }
        }
      );
  }

  getBooks() {
    let booksExpected = BookResponse.Book;
    this.httpService.getObjects('/PromoItem/', this.promoId, booksExpected)
      .subscribe(
        createResponse => {
          for (let item of createResponse) {
            this.booksSelected.push(item);
            this.itemIds.push(item.id);
          }
        }
      );
  }

  cleanItems() {
    this.booksSelected = [];
    this.tagsSelected = [];
    this.itemIds = [];
    this.assignItem();
  }

  addItem(id: number) {
    if (this.itemIds.indexOf(id) === -1) {
      if (this.applyTo === 1) {
        let responseExpected = new TagResponse.Tag();
        this.httpService.get(this.tagUrl, id, responseExpected)
          .subscribe(
            createResponse => {
              if (createResponse) {
                this.tagsSelected.push(createResponse);
                this.itemIds.push(createResponse.id);
              }
            }
          );
      } else if (this.applyTo === 2) {
        let responseExpected = new BookResponse.Book();
        this.httpService.get(this.bookUrl, id, responseExpected)
          .subscribe(
            createResponse => {
              if (createResponse) {
                this.booksSelected.push(createResponse);
                this.itemIds.push(createResponse.id);
              }
            }
          );
      }
    }
  }

  delete(value) {
    let index = this.itemIds.indexOf(+value);
    if (index !== -1) {
      this.itemIds.splice(index, 1);
      if (this.applyTo === 1) {
        this.tagsSelected.splice(index, 1);
      } else if (this.applyTo === 2) {
        this.booksSelected.splice(index, 1);
      }
    }
  }

  assignItem() {
    let strItems = this.itemIds.map(String).join();
    this.onAssign.emit(strItems);
  }
}



// WEBPACK FOOTER //
// ./src/app/promos/promo-assign/promo-assign.component.ts